import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { BootstrapVue } from 'bootstrap-vue'
import VueYoutube from 'vue-youtube'
import VueParticles from 'vue-particles'
//import VueI18n from 'vue-i18n';
//import idiomaService from './idiomaService'; // Importa el servicio de idioma

import Scrollspy from 'vue2-scrollspy';
var VueScrollTo = require('vue-scrollto');

Vue.config.productionTip = false
Vue.use(VueYoutube)
Vue.use(VueParticles)
//Vue.use(VueI18n)

Vue.config.productionTip = false

//const i18n = new VueI18n({
//  locale: 'es', // Idioma predeterminado (puede ser cualquier idioma que desees)
 // fallbackLocale: 'es', // Idioma de respaldo si no se puede cargar el idioma seleccionado
//});


Vue.use(Scrollspy);
Vue.use(VueScrollTo)
Vue.use(BootstrapVue)

import 'bootstrap-vue/dist/bootstrap-vue.css'

// Carga las traducciones al iniciar la aplicación
//idiomaService.loadTranslations('es') // Carga el idioma predeterminado
 // .then(translations => {
   // i18n.setLocaleMessage('es', translations); // Establece las traducciones cargadas
new Vue({
  router,
  render: h => h(App)//,
  //i18n,
}).$mount('#app')
;
 // })
 // .catch(error => {
  //  console.error(`Error al cargar traducciones: ${error}`);
 // });